import request from '@/utils/request'
import api from '@/api'
import { arrayObjectSort } from '@/utils'

const state = () => ({})
const getters = {}

const mutations = {}

const actions = {
  //获取服务计划节点树
  GetSopNodeTree(context, params) {
    return request({
      url: api.GetSopNodeTree,
      method: 'GET',
      params,
    })
  },
  //获取节点模块列表及模块内容
  GetNodeModulesInfo(context, params) {
    return request({
      url: api.GetNodeModulesInfo,
      method: 'GET',
      params,
    })
  },

  //获取产品服务列表
  GetMyProductList(context, params) {
    return request({
      url: api.GetMyProductList,
      method: 'GET',
      params,
    })
  },
  //获取评价维度列表
  GetList(context, params) {
    return request({
      url: api.GetList,
      method: 'GET',
      params,
    })
  },
  //学员发送课堂互动消息
  MenteeSendMsg(context, params) {
    return request({
      url: api.MenteeSendMsg,
      method: 'POST',
      data: params,
    })
  },
  //提交评价
  Comment(context, params) {
    return request({
      url: api.Comment,
      method: 'POST',
      data: params,
    })
  },
  //提交作業
  SubmitHomework(context, params) {
    return request({
      url: api.SubmitHomework,
      method: 'POST',
      data: params,
    })
  },
  //获取媒体信息
  ShowAssetDetail(context, params) {
    return request({
      url: api.ShowAssetDetail,
      method: 'GET',
      params,
    })
  },
  //获取产品详情
  GetDetail(context, params) {
    return request({
      url: api.GetDetail,
      method: 'GET',
      params,
    })
  },
  //获取产品引用的案例ID列表
  GetCaseIds(context, params) {
    return request({
      url: api.GetCaseIds,
      method: 'GET',
      params,
    })
  },
  //按ID列表获取帖子列表
  SelectByIdList(context, params) {
    return request({
      url: api.SelectByIdList,
      method: 'POST',
      data: params,
    })
  },
  FormBindFrom(context, params) {
    return request({
      url: api.FormBindFrom,
      method: 'POST',
      data: params,
    })
  },
  RecordDeliveryPalyTime(context, params) {
    return request({
      url: api.RecordDeliveryPalyTime,
      method: 'POST',
      data: params,
    })
  },

  GetSopFormSimpleInfo(context, params) {
    return request({
      url: api.GetSopFormSimpleInfo,
      method: 'GET',
      params,
    })
  },

  PackageReceive(context, params) {
    return request({
      url: api.PackageReceive,
      method: 'POST',
      data: params,
    })
  },
  SOPMenteeFinishNode(context, params) {
    return request({
      url: api.SOPMenteeFinishNode,
      method: 'PATCH',
      data: params,
    })
  },
  SOPMenteeRestartNode(context, params) {
    return request({
      url: api.SOPMenteeRestartNode,
      method: 'PATCH',
      data: params,
    })
  },
  AssetList(context, params) {
    return request({
      url: api.AssetList,
      method: 'POST',
      data: params,
    })
  },
  CheckAndFinishForm(context, params) {
    return request({
      url: api.CheckAndFinishForm,
      method: 'PATCH',
      params,
    })
  },
  GetAllSolutions(context, params) {
    return request({
      url: api.GetAllSolutions,
      method: 'GET',
      params,
    })
  },
  GetMySolusions(context, params) {
    return request({
      url: api.GetMySolusions,
      method: 'GET',
      params,
    })
  },
  CreateOpenClassForm(context, params) {
    return request({
      url: api.CreateOpenClassForm,
      method: 'POST',
      data: params,
    })
  },
  CourseSharingCheck(context, params) {
    return request({
      url: api.CourseSharingCheck,
      method: 'GET',
      params,
    })
  },
  // 创建服务计划购买订单
  CreateFormPurchaseOrder(context, params) {
    return request({
      url: api.CreateFormPurchaseOrder,
      method: 'POST',
      data: params,
    })
  },
  RecordNodeStayDuration(context, params) {
    return request({
      url: api.RecordNodeStayDuration,
      method: 'POST',
      data: params,
    })
  },
  ProductAgreementGetAgreement(context, params) {
    return request({
      url: api.ProductAgreementGetAgreement,
      method: 'GET',
      params,
    })
  },
  GetProductWorkflow(context, params) {
    return request({
      url: api.GetProductWorkflow,
      method: 'GET',
      params,
    })
  },
  GetAgreementInfo(context, params) {
    return request({
      url: api.GetAgreementInfo,
      method: 'GET',
      params,
    })
  },
  FormSignAgreement(context, params) {
    return request({
      url: api.FormSignAgreement,
      method: 'POST',
      data: params,
    })
  },
  FormGetAgreementWithSignatureInfo(context, params) {
    return request({
      url: api.FormGetAgreementWithSignatureInfo,
      method: 'GET',
      params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
